import {
    Grid, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead,
    TableRow, TableSortLabel, Tooltip, IconButton,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { iconSize } from 'assets/theme/iconSize';
import { setLoading, useMaterialUIController } from 'context';
import { ITableProps } from '@types_main/itable.props';
import { useAlert } from '@components/showAlert/useAlertHook';
import { useTranslation } from 'react-i18next';
import { apiErrorMessage } from '@functions/api-error-message';
import { CrmTagChip } from '@layouts/pages/CRM/kanban-board/components/shared/crm-tag-chip';
import { TagResponse } from '../services/responses/tag.response';
import { TagService } from '../services/tag.service';

export function TagTable(props: ITableProps<TagResponse>) {
    const { t } = useTranslation();
    const { orderDirection, handleOrderList, data, editAction } = props;
    const [, dispatch] = useMaterialUIController();
    const { showAlert, alertDelete } = useAlert();

    function doDelete(id: string) {
        setLoading(dispatch, true);
        new TagService()
            .deleteById(id)
            .then(() => {
                showAlert(t('tags.excluirSucesso'), 'success', 2500);
                props.setRefresh(!props.refresh);
            })
            .catch((err) => showAlert(apiErrorMessage(err), 'error', 3000))
            .finally(() => setLoading(dispatch, false));
    }

    return (
        <Grid>
            <TableContainer sx={{ marginTop: '15px', maxHeight: '60vh', overflowY: 'auto' }}>
                <Table size="medium">
                    <TableHead sx={{ position: 'sticky', top: 0, backgroundColor: 'background.card' }}>
                        <TableRow hover>
                            <TableCell width="45%">
                                {t('general.nome')}
                                <TableSortLabel
                                    active={true}
                                    direction={orderDirection}
                                    onClick={handleOrderList}
                                ></TableSortLabel>
                            </TableCell>
                            <TableCell width="37%">{t('tags.previa')}</TableCell>
                            <TableCell width="18%" align="center">
                                {t('general.acoes')}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.data ? (
                            data.data.records.length > 0 ? (
                                data.data.records.map((item) => (
                                    <TableRow hover key={item.id}>
                                        <TableCell>{item.name}</TableCell>
                                        <TableCell>
                                            {/* A tag como aparece no card, não a cor solta num quadradinho. */}
                                            <CrmTagChip name={item.name} color={item.color} />
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <Tooltip title={t('general.editar')}>
                                                    <IconButton size="small" sx={{ p: 0.25 }} onClick={() => editAction(item.id)}>
                                                        <EditIcon
                                                            style={iconSize}
                                                        />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title={t('general.excluir')}>
                                                    <IconButton
                                                        size="small"
                                                        sx={{ p: 0.25 }}
                                                        onClick={() =>
                                                            alertDelete(
                                                                item.id,
                                                                doDelete,
                                                                item.name,
                                                                t('tags.excluirConfirm')
                                                            )
                                                        }
                                                    >
                                                        <DeleteIcon
                                                            sx={iconSize}
                                                            color="error"
                                                        />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow hover>
                                    <TableCell colSpan={3} align="center">
                                        {t('general.nenhumRegistro')}
                                    </TableCell>
                                </TableRow>
                            )
                        ) : (
                            Array.from({ length: 5 }, (_, i) => i).map((index) => (
                                <TableRow hover key={index}>
                                    <TableCell><Skeleton height={30} variant="rectangular" /></TableCell>
                                    <TableCell><Skeleton height={30} variant="rectangular" /></TableCell>
                                    <TableCell><Skeleton height={30} variant="rectangular" /></TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
}
